import Modal from 'react-modal'
import './login-modal.css';
import React from 'react';

class LogoutFeedbackModal extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showLogoutFeedback: false,
    }
  }

  openLogoutFeedback = () => {
    this.setState({ showLogoutFeedback: true });
  }

  closeLogoutFeedback = () => {
    window.location.reload()
    this.setState({ showLogoutFeedback: false });
  }

  render() {
    return (
      <div>
        <Modal
          isOpen={this.state.showLogoutFeedback}
          onRequestClose={this.closeLogoutFeedback}
          className="Modal"
          overlayClassName="Overlay">
          <i className='bx bxs-check-circle' ></i>
          <div className="title">You’re now logged out!</div>
          <div className="cancel" onClick={this.closeLogoutFeedback}>Click to return</div>
        </Modal>
      </div>
    );
  }
}

export default LogoutFeedbackModal


// WEBPACK FOOTER //
// ./src/components/LogoutFeedbackModal.js